import {IGameFilterDefinition} from "../filters-definitions/game-filter-definition.interface";
import {VendorFilterDefinition} from "../filters-definitions/vendor/vendor.filter-definition";
import {FilterCategoryDefinitionBase} from "./filter-category-definition-base";
import {CategoryDefinitionId} from "./filter-category-definition.interface";
import {Check} from "@sparkware/app-utils";
import {GameVendorId} from "../../game-vendor/game-vendor-id.enum";

export class GameVendorFiltersCategoryDefinition extends FilterCategoryDefinitionBase {

    get id(): CategoryDefinitionId {
        return 'vendors';
    }

    get title(): string {
        return this.services.translation.translate('GAME_STUDIOS');
    }

    get hasItsOwnFiltersOrder(): boolean {
        return !Check.isEmpty(this.services.configuration.data.generalSettings.filters?.advancedFilters?.preferredVendorFilters);
    }

    public getAllPreferredVendorsFilters(): VendorFilterDefinition[] {
        return [
            new VendorFilterDefinition("vendor_888", [this.services.gamesVendor.getVendor(GameVendorId.V_888)], this.services.translation.translate("BRAND_EXCLUSIVE_FILTER", {brandName: this.services.configuration.data.generalSettings.filters?.exclusiveFilterBrandName ?? "888"})),
            new VendorFilterDefinition("vendor_ags", [this.services.gamesVendor.getVendor(GameVendorId.V_AGS)]),
            new VendorFilterDefinition("vendor_amatic", [this.services.gamesVendor.getVendor(GameVendorId.V_Amatic)]),
            new VendorFilterDefinition("vendor_authentic", [this.services.gamesVendor.getVendor(GameVendorId.V_Authentic)]),
            new VendorFilterDefinition("vendor_ainsworth", [this.services.gamesVendor.getVendor(GameVendorId.V_Ainsworth)]),
            new VendorFilterDefinition("vendor_blueprint", [this.services.gamesVendor.getVendor(GameVendorId.V_Blueprint)]),
            new VendorFilterDefinition("vendor_darwin", [this.services.gamesVendor.getVendor(GameVendorId.V_Darwin)]),
            new VendorFilterDefinition("vendor_egt", [this.services.gamesVendor.getVendor(GameVendorId.V_EGT)]),
            new VendorFilterDefinition("vendor_elk", [this.services.gamesVendor.getVendor(GameVendorId.V_Elk)]),
            new VendorFilterDefinition("vendor_evolution", [this.services.gamesVendor.getVendor(GameVendorId.V_Evolution)]),
            new VendorFilterDefinition("vendor_eyecon", [this.services.gamesVendor.getVendor(GameVendorId.V_Eyecon)]),
            new VendorFilterDefinition("vendor_gamesglobal", [this.services.gamesVendor.getVendor(GameVendorId.V_GamesGlobal)]),
            new VendorFilterDefinition("vendor_gamingrealms", [this.services.gamesVendor.getVendor(GameVendorId.V_GamingRealms)]),
            new VendorFilterDefinition("vendor_gamomat", [this.services.gamesVendor.getVendor(GameVendorId.V_Gamomat)]),
            new VendorFilterDefinition("vendor_greentube", [this.services.gamesVendor.getVendor(GameVendorId.V_Greentube)]),
            new VendorFilterDefinition("vendor_h5", [this.services.gamesVendor.getVendor(GameVendorId.V_H5)]),
            new VendorFilterDefinition("vendor_habanero", [this.services.gamesVendor.getVendor(GameVendorId.V_Habanero)]),
            new VendorFilterDefinition("vendor_igt", [this.services.gamesVendor.getVendor(GameVendorId.V_IGT)]),
            new VendorFilterDefinition("vendor_inspired", [this.services.gamesVendor.getVendor(GameVendorId.V_Inspired)]),
            new VendorFilterDefinition("vendor_isoftbet", [this.services.gamesVendor.getVendor(GameVendorId.V_iSoftBet)]),
            new VendorFilterDefinition("vendor_lightningbox", [this.services.gamesVendor.getVendor(GameVendorId.V_LightningBox)]),
            new VendorFilterDefinition("vendor_lnw", [this.services.gamesVendor.getVendor(GameVendorId.V_LNW), this.services.gamesVendor.getVendor(GameVendorId.V_LNW2)], "LNW"),
            new VendorFilterDefinition("vendor_merkur", [this.services.gamesVendor.getVendor(GameVendorId.V_Merkur)]),
            new VendorFilterDefinition("vendor_mga", [this.services.gamesVendor.getVendor(GameVendorId.V_MGA)]),
            new VendorFilterDefinition("vendor_netent", [this.services.gamesVendor.getVendor(GameVendorId.V_NetEnt)]),
            new VendorFilterDefinition("vendor_nextgen_bigtime", [this.services.gamesVendor.getVendor(GameVendorId.V_NextGenBigTime)], `Big Time`), //TODO ?
            new VendorFilterDefinition("vendor_nextgen_chanceinteractive", [this.services.gamesVendor.getVendor(GameVendorId.V_NextGenChanceInteractive)], `Reel Play`),
            new VendorFilterDefinition("vendor_nolimitcity", [this.services.gamesVendor.getVendor(GameVendorId.V_NoLimitCity)]),
            new VendorFilterDefinition("vendor_playngo", [this.services.gamesVendor.getVendor(GameVendorId.V_PlayNGo)], `Play'n GO`),
            new VendorFilterDefinition("vendor_playtech", [this.services.gamesVendor.getVendor(GameVendorId.V_PlayTech)], `Playtech`),
            new VendorFilterDefinition("vendor_pragmatic", [this.services.gamesVendor.getVendor(GameVendorId.V_Pragmatic)]),
            new VendorFilterDefinition("vendor_quickspin", [this.services.gamesVendor.getVendor(GameVendorId.V_Quickspin)]),
            new VendorFilterDefinition("vendor_redrake", [this.services.gamesVendor.getVendor(GameVendorId.V_RedRake)]),
            new VendorFilterDefinition("vendor_redtiger", [this.services.gamesVendor.getVendor(GameVendorId.V_RedTiger)]),
            new VendorFilterDefinition("vendor_rubyplay", [this.services.gamesVendor.getVendor(GameVendorId.V_RubyPlay)]),
            new VendorFilterDefinition("vendor_sigma", [this.services.gamesVendor.getVendor(GameVendorId.V_Sigma)]),
            new VendorFilterDefinition("vendor_skywind", [this.services.gamesVendor.getVendor(GameVendorId.V_Skywind)]),
            new VendorFilterDefinition("vendor_spribe", [this.services.gamesVendor.getVendor(GameVendorId.V_Spribe)]),
            new VendorFilterDefinition("vendor_thunderkick", [this.services.gamesVendor.getVendor(GameVendorId.V_Thunderkick)]),
            new VendorFilterDefinition("vendor_wizard", [this.services.gamesVendor.getVendor(GameVendorId.V_Wizard)]),
            new VendorFilterDefinition("vendor_wmg", [this.services.gamesVendor.getVendor(GameVendorId.V_WMG)]),
            new VendorFilterDefinition("vendor_yggdrasil", [this.services.gamesVendor.getVendor(GameVendorId.V_Yggdrasil)]),
            new VendorFilterDefinition("vendor_everi", [this.services.gamesVendor.getVendor(GameVendorId.V_Everi)]),
            new VendorFilterDefinition("vendor_push_gaming", [this.services.gamesVendor.getVendor(GameVendorId.V_PushGaming)], `Push Gaming`),
            new VendorFilterDefinition("vendor_edict", [this.services.gamesVendor.getVendor(GameVendorId.V_Edict)]),
            new VendorFilterDefinition("vendor_gamevy", [this.services.gamesVendor.getVendor(GameVendorId.V_Gamevy)]),
            new VendorFilterDefinition("vendor_wazdan", [this.services.gamesVendor.getVendor(GameVendorId.V_Wazdan)]),
        ];
    }

    private _getPreferredVendorFiltersForCurrentSkin(): VendorFilterDefinition[] {
        const preferredVendorsFiltersIds = this.services.configuration.data.generalSettings.filters?.advancedFilters?.preferredVendorFilters ?? [];
        if (preferredVendorsFiltersIds.length === 0) {
            return [...this.getAllPreferredVendorsFilters()];
        }

        const allPreferredVendorsFiltersMap = this.getAllPreferredVendorsFilters().toDictionary(f => f.id);
        const result: VendorFilterDefinition[] = [];
        for (let filterId of preferredVendorsFiltersIds) {
            const filter = allPreferredVendorsFiltersMap[filterId];
            if (filter) {
                result.push(filter)
            } else {
                this.services.logger.error(`There is no definition for game vendor filter with id ${filterId}`)
            }
        }

        return result;
    }

    protected _loadAvailableFilters(): IGameFilterDefinition[] {
        const filters = this._getPreferredVendorFiltersForCurrentSkin();
        let preferredVendorsIds: number[] = filters.selectMany(f => f.vendors?.map(vendor => vendor?.id));
        const otherVendorsIds: number[] = [];

        const allVendorsIds = Object.keys(this.services.sdk.getGamesVendors()).map(id => parseInt(id));
        for (let vendorId of allVendorsIds) {
            if (!preferredVendorsIds.includes(vendorId)) {
                otherVendorsIds.push(vendorId);
            }
        }

        if (otherVendorsIds.length > 0) {
            filters.push(new VendorFilterDefinition('vendor_others', otherVendorsIds.map(vendorId => this.services.gamesVendor.getVendor(vendorId)), this.services.translation.translate('OTHER')));
        }


        return filters;
    }

}
